// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"403":"d7da0cee","510":"bfeb38d0","636":"cf653896","752":"de4f8d3e"}[chunkId] + ".chunk.css";
};